import { useEffect, useState } from 'react';

import { getUserWidgetsMetadata } from 'api/generated/user-widgets/user-widgets';

import { useCurrentUser } from 'hooks/api/use-current-user';

import { Box } from 'ui/box';

import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import MasonryGrid from 'containers/user/home/components/masonry-grid/masonry-grid';
import { Loader } from 'ui/loader';

import getWidgetsSet from 'containers/user/home/components/widgets/helpers/helpers';
import type { MasonryWidget } from 'containers/user/home/components/masonry-grid/masonry-grid.helper';

import HomeReportTiles from './components/home-report-tiles';

interface WidgetItem {
  id: string | number;
  widget: { type: 'ANNOUNCEMENT' | 'RELEASE_NOTE' | 'GOAL' | 'VISUAL' };
}

const Home = (): React.JSX.Element => {
  const currentUser = useCurrentUser();
  const [widgets, setWidgets] = useState<MasonryWidget[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const removeWidget = (widgetId: string | number): void => {
    setWidgets((prevWidgets) =>
      prevWidgets.filter((widget) => widget.id !== widgetId)
    );
  };

  useEffect(() => {
    const fetchWidgets = async (): Promise<void> => {
      if (!currentUser?.data?.oktaUserId) {
        return;
      }

      setLoading(true);
      try {
        const responseData = (await getUserWidgetsMetadata(
          currentUser.data.oktaUserId
        )) as unknown as WidgetItem[];

        const formattedWidgets = await getWidgetsSet(
          responseData,
          currentUser,
          removeWidget
        );

        setWidgets(formattedWidgets);
      } catch (error) {
        console.error('Error fetching widgets:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchWidgets();
  }, [currentUser.data?.oktaUserId]);

  return (
    <ResponsiveWrapper>
      <h1
        className="my-5 font-black font-family text-4xl text-navy-800"
        data-testid="home-page-title"
      >
        Welcome to MARKETview
      </h1>
      <Box sx={{ position: 'relative' }}>
        <Loader loading={loading} overlay="transparent" fullScreen={false} />
        {widgets.length > 0 && !loading ? (
          <MasonryGrid widgets={widgets} />
        ) : null}
      </Box>
      <HomeReportTiles />
    </ResponsiveWrapper>
  );
};

export default Home;
